/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Ws message type dto
 */
export interface WsMessageTypeDto {
  wsMessageType?: WsMessageTypeDto.WsMessageTypeEnum;
}
export namespace WsMessageTypeDto {
  export const WsMessageTypeEnum = {
    Error: 'error',
    BalanceV2: 'balanceV2',
    ActiveOrders: 'active-orders',
    Orders: 'orders',
    Candles: 'candles',
    PairPrice: 'pair-price',
    Rate: 'rate',
    Transfers: 'transfers',
    ReportUpdate: 'report_update',
    AssetRefPrice: 'asset-ref-price',
  } as const;
  export type WsMessageTypeEnum =
    (typeof WsMessageTypeEnum)[keyof typeof WsMessageTypeEnum];
}
